module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Bold-Hestia.7c7e657.eot";